import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import {
  Box,
  Grid,
  Container,
  Typography,
  colors,
  useTheme,
  CardActions,
  Button
} from '@material-ui/core';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIcon from '@material-ui/icons/Phone';
import TabletIcon from '@material-ui/icons/Tablet';

//Redux
import { useSelector, useDispatch } from "react-redux";

//My Components
import Computations from 'src/components/applications/Computation';
import { useEffect, useState } from 'react';



const TrafficByDevice = (props) => {
  const theme = useTheme();
  const { calculator: { principal, rate, term, rateTerm, total, amortization } } = useSelector(state => state.data);
  const { user } = useSelector(state => state.auth);
  const [location, setLocation] = useState({})
  const [details, setDetails] = useState({});




  useEffect(() => {
    if(user && user.personalDetails){
      setDetails(user.personalDetails);
    }

    if(user && user.location) {
      setLocation(user.location);
    }

  }, [user])



  return (
  
      <div>
        <Box
          sx={{
            display: 'block',
            justifyContent: 'center',
            pt: 1
          }}
        >
            <Container maxWidth={false}>
{/* <Grid
container
        spacing={1}
      >
           <Grid
          item
          lg={6}
          sm={6}
          xl={6}
          xs={12}
        >
        <Computations/>

        </Grid> */}
        {/* <Grid
          item
          lg={6}
          sm={6}
          xl={6}
          xs={12}
        >
    */}
            <Box
              sx={{
                pt: 3,
                p: 2
              }}
            >
              <Typography
                color="textPrimary"
                variant="h3"
                className="text-center"
              >
                LOAN AGREEMENT
              </Typography>
              <br/>
              <Typography
                 variant="h5"
                 color="textPrimary"
              >
               THE PARTIES. 
             </Typography>
             <Typography className="ml-4 mb-2">This Personal Loan Agreement("Agreement") made <b className="text-danger">{moment().format('dddd, MMMM Do YYYY')}</b> is by and between:</Typography>
             <Typography variant="body1" className="mb-3">Borrower: <i className="text-danger ml-1">{details.firstName} {details.middleName ? details.middleName : ''} {details.lastName}</i>, residence of <i className="text-danger">{location.address}</i>, City of <i className="text-danger">{location.city}</i>, province of <i className="text-danger">{location.state}</i>, Zip Code of <i className="text-danger">{location.zip_code}</i> &nbsp;{location.country}, ("Borrower") and agress to pay:</Typography>
             <Typography variant="body1">Lender: <i className="text-danger ml-1">Transac Financing Inc</i>, located at <i className="text-danger">Barangay 56</i>, City of <i className="text-danger">Tacloban City</i>, province of <i className="text-danger">Leyte</i>, Zip Code of <i className="text-danger">6500</i> &nbsp;{location.country}, ("Lender").</Typography>
             <br/><br/>
              <Typography variant="h4" className="text-center">TERMS OF REPAYMENT</Typography>
              <br/>
              <Typography variant="h5">1. Loan Amount</Typography>
              <Typography variant="body1" className="ml-4">The Borrower agrees to repay <u>&nbsp;₱{total}&nbsp;</u> (“The Loan”).</Typography>
              <br/>
              <Typography variant="h5">2. Interest Rate</Typography>
              <Typography variant="body1" className="ml-4">Both Parties agree upon an interest rate of <u>&nbsp;{Number(rate * 100).toFixed(1)}%&nbsp;</u> that is to be accrued <u>&nbsp;{rateTerm}&nbsp;</u>.</Typography>
              <br/>
              <Typography variant="h5">3. Term</Typography>
              <Typography variant="body1" className="ml-4">The Loan Term is of <u>&nbsp;{term}&nbsp;</u>&nbsp;{rateTerm === 'Weekly' ? `Weekly period/s (${Number(term * 7)}days)` : `Semi-monthly period/s (${Number(term * 15)}days)`}</Typography>
              <br/>
              <Typography variant="h5">4. Terms of Repayment</Typography>
              <Typography variant="body1" className="ml-4">The Borrower agrees to repay the lender <u>&nbsp;₱{amortization}&nbsp;</u>amount on a <u>&nbsp;{rateTerm}&nbsp;</u> basis, until fully paid.</Typography>
              <br/>
              <Typography variant="body1" className="ml-4">Principal Amount: ₱<u>&nbsp;{principal}&nbsp;</u>.</Typography>
              <Typography variant="body1" className="ml-4 mt-2">Interest: ₱<u>&nbsp;{Number(principal * (rate * term)).toFixed()}&nbsp;</u>.</Typography>

            </Box>
            {/* </Grid>
         
</Grid> */}
</Container>
        </Box>
      </div>
  );
};

export default TrafficByDevice;
